export enum TrackingEvent {
  AvatarUpdated = `[User-Sidebar] Updated Avatar`,
  UserDataLoaded = `[User-Sidebar] User Data Loaded`,
  MostViewedLoaded = `[User-Sidebar] Most Viewed Loaded`,
  LinkClicked = `[User-Sidebar] Link Clicked`,
  Opened = `[User-Sidebar] Opened`,
  Closed = `[User-Sidebar] Closed`,
  TabSelected = `[User-Sidebar] Tab Selected`,
  BioClear = `[User-Sidebar] Bio Clear`,
  BioSave = `[User-Sidebar] Bio Save`,
}
